export default class DomHelper {
    static matches(el, selector) {
        if (!this.isDOMElement(el)) {
            return false;
        }

        return (el.matches
            || el.matchesSelector
            || el.msMatchesSelector
            || el.mozMatchesSelector
            || el.webkitMatchesSelector
            || el.oMatchesSelector).call(el, selector);
    }

    static closest(el, selector, container) {
        if (!el) {
            return;
        }

        if (!container) {
            container = document.body;
        }

        let element = el;

        while (!this.matches(element, selector) && element.parentNode && element !== container) {
            element = element.parentNode;
        }

        return this.matches(element, selector) ? element : undefined;
    }

    static isDOMElement(el) {
        return el && (el instanceof HTMLElement || el instanceof SVGElement ||
            (el.constructor && el.constructor.name && el.constructor.name.search(/\HTML.+Element/) > -1));
    }

    static isLinkElement(el) {
        return this.isDOMElement(el) && ['IMG', 'A'].indexOf(el.tagName.toUpperCase()) >= 0;
    }

    static getClickTarget(ev) {
        let target = ev.target;

        if ((window.SVGElementInstance) && (target instanceof SVGElementInstance) && target.correspondingUseElement)
        {
            target = target.correspondingUseElement;
        }

        return target;
    }

    static removeElement(el) {
        if (this.isDOMElement(el)) {
            const parent = this.parentElement(el);

            if (parent) {
                parent.removeChild(el);
            }
        }
    }

    static removeElements(elements) {
        const elementsArray = Array.isArray(elements) ? elements : Array.prototype.slice.call(elements);

        elementsArray.forEach((el) => {
            this.removeElement(el);
        });
    }

    static parentElement(el) {
        if (this.isDOMElement(el)) {
            if (el.parentNode) {
                return el.parentNode;
            }

            // IE & Edge workaround. IE & Edge can't get the parentNode on svg 'use' element.
            if (el.correspondingUseElement) {
                return el.correspondingUseElement.parentNode;
            }
        }
    }

    static hasClass(classname, el) {
        if (classname && this.isDOMElement(el)) {
            const testString = el.className.baseVal || el.className;

            return Boolean(!!testString && testString.length && (new RegExp(`(^| )${classname}( |$)`, 'i')).test(testString));
        }

        return false;
    }

    static addClass(classname, el) {
        if (classname && this.isDOMElement(el)) {
            el.classList.add(classname);
        }
    }

    static removeClass(classname, el) {
        if (classname && this.isDOMElement(el)) {
            el.classList.remove(classname);
        }
    }

    static addClasses(classnames, el) {
        if (classnames && classnames.length && this.isDOMElement(el)) {
            for (var i = 0; i < classnames.length; i++) {
                if (classnames[i]) {
                    el.classList.add(classnames[i]);
                }
            }
        }
    }

    static removeClasses(classnames, el) {
        if (classnames && classnames.length && this.isDOMElement(el)) {
            for (var i = 0; i < classnames.length; i++) {
                if (classnames[i]) {
                    el.classList.remove(classnames[i]);
                }
            }
        }
    }
}